// Author Liang Gang Qiang
// Date 2023-03-10 10:05:35

import * as model from "@/model/sithMes/prd/SithMesPrdProjectProfitCenterModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesPrdProjectProfitCenter(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_PRD_URL,
    })
    .buildStore()
